import ProductPageSettingPanel from './productPageSettingPanel.container';

export default ProductPageSettingPanel